import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const SmsStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
      padding: "20px 25px",
      borderRadius: "15px",
      maxWidth: "450px",
    },
    fieldTitle: {
      fontSize: "22px",
      paddingBottom: "5px",
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.text.primary,
    },
    fieldDescription: {
      fontSize: "16px",
      paddingBottom: "5px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
  }),
);
